import openWindow from '@/script/openWindow.mjs'

export default () => {
    const onClick = () => openWindow(
        '/Ai',
        {scene: 'GENERATE_AIS_PATTERN'}
    )

    return {
        title: '影响范围分析任务（基线版）',
        onClick,
    }
}
